import { AdminInquiryConst } from "../Constants/AdminInquiryConstants";
import { BASE_URL, API_ENDPOINTS } from "../../config/api.config";
import { apiFetch, getAuthHeaders } from "../../utils/apiHelper";

export const FetchMyAdminInquiries = () => {
  return async (dispatch) => {
    dispatch({ type: AdminInquiryConst.FETCH_MY_INQUIRIES_REQUEST });
    try {
      const response = await apiFetch(
        `${BASE_URL}${API_ENDPOINTS.ADMIN_INQUIRIES_MY}`,
        { headers: getAuthHeaders() },
        dispatch
      );
      const result = await response.json();
      if (result.statusCode === 200) {
        dispatch({ type: AdminInquiryConst.FETCH_MY_INQUIRIES_SUCCESS, result });
      } else {
        dispatch({ type: AdminInquiryConst.FETCH_MY_INQUIRIES_FAIL, result });
      }
    } catch (error) {
      dispatch({ type: AdminInquiryConst.FETCH_MY_INQUIRIES_FAIL, result: { message: error.message } });
    }
  };
};

export const CreateAdminInquiry = (subject, message, onSuccess, onError) => {
  return async (dispatch) => {
    dispatch({ type: AdminInquiryConst.CREATE_INQUIRY_REQUEST });
    try {
      const response = await apiFetch(
        `${BASE_URL}${API_ENDPOINTS.ADMIN_INQUIRIES}`,
        {
          method: "POST",
          headers: getAuthHeaders(),
          body: JSON.stringify({ subject, message }),
        },
        dispatch
      );
      const result = await response.json();
      if (result.statusCode === 200 || result.statusCode === 201) {
        dispatch({ type: AdminInquiryConst.CREATE_INQUIRY_SUCCESS, result });
        onSuccess && onSuccess(result.data);
      } else {
        dispatch({ type: AdminInquiryConst.CREATE_INQUIRY_FAIL, result });
        onError && onError(result.message);
      }
    } catch (error) {
      dispatch({ type: AdminInquiryConst.CREATE_INQUIRY_FAIL, result: { message: error.message } });
      onError && onError(error.message);
    }
  };
};

export const FetchAdminInquiryMessages = (inquiryId) => {
  return async (dispatch) => {
    dispatch({ type: AdminInquiryConst.FETCH_MESSAGES_REQUEST });
    try {
      const response = await apiFetch(
        `${BASE_URL}${API_ENDPOINTS.ADMIN_INQUIRY_MESSAGES}/${inquiryId}/messages`,
        { headers: getAuthHeaders() },
        dispatch
      );
      const result = await response.json();
      if (result.statusCode === 200) {
        dispatch({ type: AdminInquiryConst.FETCH_MESSAGES_SUCCESS, result });
      } else {
        dispatch({ type: AdminInquiryConst.FETCH_MESSAGES_FAIL, result });
      }
    } catch (error) {
      dispatch({ type: AdminInquiryConst.FETCH_MESSAGES_FAIL, result: { message: error.message } });
    }
  };
};

export const SendAdminInquiryMessage = (inquiryId, message, onSuccess, onError) => {
  return async (dispatch) => {
    dispatch({ type: AdminInquiryConst.SEND_MESSAGE_REQUEST });
    try {
      const response = await apiFetch(
        `${BASE_URL}${API_ENDPOINTS.ADMIN_INQUIRY_MESSAGES}/${inquiryId}/messages`,
        {
          method: "POST",
          headers: getAuthHeaders(),
          body: JSON.stringify({ message }),
        },
        dispatch
      );
      const result = await response.json();
      if (result.statusCode === 200 || result.statusCode === 201) {
        dispatch({ type: AdminInquiryConst.SEND_MESSAGE_SUCCESS, result });
        onSuccess && onSuccess(result.data);
      } else {
        dispatch({ type: AdminInquiryConst.SEND_MESSAGE_FAIL, result });
        onError && onError(result.message);
      }
    } catch (error) {
      dispatch({ type: AdminInquiryConst.SEND_MESSAGE_FAIL, result: { message: error.message } });
      onError && onError(error.message);
    }
  };
};

export const ClearAdminInquiryAction = () => ({ type: AdminInquiryConst.CLEAR_ACTION });
